import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default props => (
    <div>
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                {"Handelsbetingelser ved køb af et HandsOn Booking program"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Målet med dette program er at kunne tilbyde et redskab, som kan være en betydningsfuld hjælp i hverdagen for personer, med behov for styring af booking- og journalføringsprocessen, fakturering, kursusafholdelse med mere. Samtidig håber jeg meget, at brugerne af programmet får en god oplevelse.
                </DialogContentText>
                <DialogContentText>
                    Ved at klikke på ’Jeg accepterer HandsOn Bookings handelsbetingelser’ på oprettelsessiden, erklærer kunden, at gældende handelsbetingelser er læst, og at man er indforstået med disse.
                </DialogContentText>
                <DialogContentText>
                    Handelsbetingelserne er gældende for købere af et abonnement på programmet HandsOn Booking PRO eller hertil knyttede programmer.
                </DialogContentText>
                <DialogContentText>
                    Hjemmesiden www.handsonbooking.dk ejes og drives af HandsOn Silkeborg ApS, CVR 3952 6328, som udvikler, sælger og har driften af programmet.
                </DialogContentText>
                <DialogContentText>
                    Henvendelse til firmaet kan ske via mobilnummer:  51 73 60 00 eller e-mail: info@handsonbooking.dk
                </DialogContentText>
                <DialogContentText>
                    Det er HandsOn Silkeborg ApS, der ejer alle rettigheder til programmerne.
                </DialogContentText>
                <DialogContentText>
                    Der kan købes en brugsret til programmerne. Denne brugsret kan i særlige tilfælde inddrages uden varsel.
                </DialogContentText>
                <Typography variant="h6" gutterBottom>
                    HandsOn Booking PRO
                </Typography>
                <DialogContentText>
                    Programmet er rettet mod små klinikker, der har behov for hjælp til booking, journalføring, fakturering af behandlingsforløb og oprettelse og styring af kurser mm.
                </DialogContentText>
                <DialogContentText>
                    Programmet tilbyder også mulighed for at udsende nyhedsbreve, påmindelse via sms og mail til klienter om behandlingstid, oprettelse af kurser/events mm.
                </DialogContentText>
                <DialogContentText>
                   Prisen for denne pakke er pr 10. november 2021: 1 måneds gratis brug, derefter 149,00 kr plus moms pr måned.
                </DialogContentText>
                <Typography variant="h6" gutterBottom>
                    Priser
                </Typography>
                <DialogContentText>
                    Den gældende pris for produktet fremgår af hjemmesiden www.handsonbooking.dk. 
                </DialogContentText>
                <DialogContentText>
                    Prisen vil kunne ændres løbende – almindeligvis kun i forbindelse med tilføjelse af en funktion, eller ved almindelig prisudvikling.
                </DialogContentText>
                <DialogContentText>
                    Den aktuelle pris for en kunde fremgår tydeligt på hjemmesiden uden moms.
                </DialogContentText>
                <DialogContentText>
                    Betalingen administreres af ReePay, som opkræver beløbet for abonnementet forud en gang om måneden – indtil abonnementet opsiges. Der er et varsel for opsigelse på løbende måned.
                </DialogContentText>
                <DialogContentText>
                    Et abonnement kan startes ved at klikke på knappen ’Opret’. 
                </DialogContentText>
                <DialogContentText>
                    Når kunden modtager kvittering fra ReePay/HandsOn Booking, er man blevet bruger/abonnent af et program til en enkelt bruger.
                </DialogContentText>
                <DialogContentText>
                    Første måned er gratis. 
                </DialogContentText>
                <DialogContentText>
                    Inden udløbet af gratisperioden tilsendes der en mail, som spørger om man ønsker at blive fast abonnent.
                </DialogContentText>
                <DialogContentText>
                    Her kan man vælge at klikke på ’Her’, hvorefter man bliver videresendt til Reepay, som varetager betalingerne. Informationerne fra betalingskortet tilgår ikke HandsOn Silkeborg ApS.
                </DialogContentText>
                <DialogContentText>
                   Ønsker man ikke at fortsætte, afmeldes man automatisk efter kort tid.
                </DialogContentText>
                <DialogContentText>
                    Der tildeles hver bruger 20 gratis sms-beskeder hver måned.
                </DialogContentText>
                <DialogContentText>
                    Forbrug udover dette antal, faktureres med 0,60 kr + moms pr. stk.
                </DialogContentText>
                <Typography variant="h6" gutterBottom>
                    Misbrug
                </Typography>
                <DialogContentText>
                    HandsOn Booking søger at hindre ethvert misbrug af sine ydelser, men kan ikke garantere, at misbrug eller indtrængen i HandsOn Bookings it-systemer ikke kan forekomme.
                </DialogContentText>
                <DialogContentText>
                    Hvis kunden mistænker, at der sker misbrug af kortdata, HandsOn Bookings ydelser, eller at det er sket eller vil ske forsøg på indtrængning i HandsOn Bookings it-systemer, skal dette straks meddeles HandsOn Booking. 
                 </DialogContentText>
                <DialogContentText>
                    Tilsvarende skal kunden straks meddele HandsOn Booking, hvis kunden har været udsat for misbrug af kortdata eller forsøg på eller faktisk indtrængen i de it-systemer, som kunden anvender.
                </DialogContentText>
                <DialogContentText>
                    Hvis HandsOn Booking skønner, at kunden misbruger betalingssystemet, overtræder sikkerhedsforskrifter og retningslinjer udstedt af HandsOn Booking eller ReePay, eller at der sker misbrug fra et domæne tilhørende kunden, er HandsOn Booking uden varsel berettiget til at hindre kundens brug af betalingssystemet eller hindre adgang til betalingssystemet fra det pågældende domæne.
                </DialogContentText>
                <DialogContentText>
                    HandsOn Booking fraskriver sig ethvert ansvar, såfremt kunden ikke har overholdt almindelige sikkerhedsforskrifter og retningslinjer udstedt af HandsOn Booking eller ReePay.
                </DialogContentText>
                <Typography variant="h6" gutterBottom>
                    Opsigelse
                </Typography>
                <DialogContentText>
                    Alle købte abonnementer og medlemskaber kan til enhver tid opsiges uden varsel af HandsOn Silkeborg ApS. Opsigelse fra køber kan kun ske i løbet af en igangsat periode, som typisk strækker sig over en måned. 
                </DialogContentText>     
                <DialogContentText>
                    Opsigelse sker ved at kontakte HandsOn Booking på info@handsonbooking.dk.
                </DialogContentText>
                <DialogContentText>
                    Vælger man som bruger, ikke at betale den tilsendte faktura, vil man modtage et antal rykkere.
                </DialogContentText>  
                <DialogContentText>
                    Hvis disse heller ikke betales, blive man automatisk slettet.
                </DialogContentText>        
                <Typography variant="h6" gutterBottom>
                    Ansvarsfraskrivelse og garanti
                </Typography>
                <DialogContentText>
                    Information som ikke findes på www.handsonbooking.dk, er uden for vores kontrol. Vi kan derfor på ingen måde drages til ansvar for indholdet på disse sider.
                </DialogContentText>              
                <Typography variant="h6" gutterBottom>
                    Fortrydelsesret
                </Typography>
                <DialogContentText>
                    Køber tager sit medlemskab i brug med det samme, det er bestilt via ’Opret’-knappen, og der er derfor ikke nogen fortrydelsesret. 
                </DialogContentText>
                <DialogContentText>
                    Den første måned er en prøveperiode, som tilbydes gratis.
                </DialogContentText>
                <DialogContentText>
                    Opsiges aftalen fra købers side inden udløb af prøveperioden, vil abonnementet blive slettet uden den automatiske betaling træder i kraft.
                </DialogContentText>
                <DialogContentText>
                    Hjemmesiden www.handsonbooking.dk drives af firmaet:
                </DialogContentText>
                <DialogContentText>
                    HandsOn Silkeborg ApS - CVR: 39526328
                </DialogContentText>
                <Typography variant="h6" gutterBottom>
                    Forbehold for ændringer
                </Typography>
                <DialogContentText>
                    Handsonbooking.dk forbeholder sig ret til at ændre og opdatere de regler og betingelser, der gælder for dette website. Det er derfor vigtigt, at man løbende holder sig orienteret om eventuelle ændringer.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose} color="primary" autoFocus>
                    Læst
                </Button>
            </DialogActions>
        </Dialog>
    </div>
);
